/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { fmtBRL, fmtInt, SavedSearchSnapshot, unidadeLabel } from 'services/price_intelligence';

interface PriceIntelligenceSaveModalProps {
  show: boolean;
  onClose: () => void;
  snapshot: SavedSearchSnapshot | null;
  query: string;
  nomeSugerido?: string | null;
  loteSugerido?: string | null;
  saving: boolean;
  error: string | null;
  onConfirm: (name: string, notes: string, batchName: string) => void;
}

const PriceIntelligenceSaveModal = ({
  show,
  onClose,
  snapshot,
  query,
  nomeSugerido,
  loteSugerido,
  saving,
  error,
  onConfirm,
}: PriceIntelligenceSaveModalProps) => {
  const [name, setName] = useState<string>('');
  const [notes, setNotes] = useState<string>('');
  const [batchName, setBatchName] = useState<string>('');

  useEffect(() => {
    if (show) {
      setName((nomeSugerido || query).slice(0, 255));
      setNotes('');
      setBatchName(loteSugerido || '');
    }
  }, [show, query, nomeSugerido, loteSugerido]);

  const unidade =
    snapshot && snapshot.resumo.unidade ? `/${unidadeLabel(snapshot.resumo.unidade)}` : '';

  return (
    <Modal show={show} onHide={() => !saving && onClose()} centered>
      <div className="modal-header">
        <h5 className="modal-title">Salvar pesquisa de preços</h5>
        <button
          aria-label="Fechar"
          className="close"
          type="button"
          onClick={onClose}
          disabled={saving}
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div className="modal-body">
        {snapshot && (
          <div className="alert alert-light border mb-3" role="note">
            <div className="d-flex justify-content-between flex-wrap" style={{ gap: 8 }}>
              <span>
                <strong>{fmtInt(snapshot.resumo.n_amostras)}</strong> amostras na cesta
              </span>
              <span>
                mediana <strong>{`${fmtBRL(snapshot.resumo.mediana)}${unidade}`}</strong>
              </span>
              <span>
                menor <strong>{fmtBRL(snapshot.resumo.menor)}</strong>
              </span>
            </div>
            <small className="text-muted">
              Os valores ficam congelados na data de hoje para servir de referência da sua proposta.
            </small>
          </div>
        )}

        <div className="form-group">
          <label htmlFor="pi-save-name">Nome da pesquisa</label>
          <input
            id="pi-save-name"
            type="text"
            className="form-control"
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={255}
            disabled={saving}
          />
        </div>

        <div className="form-group">
          <label htmlFor="pi-save-batch">Lote / edital (opcional)</label>
          <input
            id="pi-save-batch"
            type="text"
            className="form-control"
            value={batchName}
            onChange={(e) => setBatchName(e.target.value)}
            maxLength={255}
            placeholder="Ex.: Pregão 12/2026 — Prefeitura de..."
            disabled={saving}
          />
          <small className="form-text text-muted">
            Pesquisas do mesmo lote ficam agrupadas em Pesquisas salvas.
          </small>
        </div>

        <div className="form-group mb-0">
          <label htmlFor="pi-save-notes">Observações (opcional)</label>
          <textarea
            id="pi-save-notes"
            className="form-control"
            rows={3}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder="Ex.: referência para o Pregão 12/2026 da Prefeitura de..."
            disabled={saving}
          />
        </div>

        {error && (
          <div className="alert alert-danger mt-3 mb-0" role="alert">
            {error}
          </div>
        )}
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={onClose}
          disabled={saving}
        >
          Cancelar
        </button>
        <button
          type="button"
          className="btn btn-primary btn-ia"
          onClick={() => onConfirm(name.trim() || query, notes.trim(), batchName.trim())}
          disabled={saving || !name.trim()}
        >
          {saving ? 'Salvando…' : 'Salvar pesquisa'}
        </button>
      </div>
    </Modal>
  );
};

export default PriceIntelligenceSaveModal;
